
import React, { Component } from 'react';import PropTypes from 'prop-types';
import SegmentList from 'components/Lists/SegmentList';
import CategoryList from 'components/Lists/CategoryList';
import Targetinfo from 'components/Formaters/Targetinfo';


import {Card, CardTitle} from 'material-ui/Card';

const style = {
  width: 300,
  margin: 10,
  cursor: "pointer",
}

export default class BrandCard extends Component {


  static contextTypes = {
    router: PropTypes.object
  };

  handleClick = (e) => {
    this.context.router.history.push("/media/"+this.props.id);
  }

  render() {

    return (
      <div className="CardRow" onClick={this.handleClick}>

        { this.props.brand.logoUrl ?
        <img className="Card_logo" alt="" src={this.props.brand.logoUrl} />
        :
        <span className="Card_logo"></span>
        }

        <span className="CardRow__Name">{this.props.brand.name}</span>

        <div className="CardText" >
         { this.props.brand.segments &&
          <SegmentList label=" " segments={this.props.brand.segments}></SegmentList>
          }
          { this.props.brand.categories &&
            <CategoryList label=" " categories={this.props.brand.categories}></CategoryList>
          } 
         </div>
          <div className="CardText">
            <Targetinfo item={this.props.brand} />
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Brand/BrandRow.jsx